import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';

import { FieldCheckbox } from '../../components';

import css from './FieldCheckboxGroupWithQuantity.module.css';

const FieldCheckboxGroupWithQuantity = props => {
  const {
    arrayName,
    options,
    optionLabelClassName,
    rootClassName,
    quantityClassName,
    maxOptionsMaybe,
    className,
    intl,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const validateOptions = value => {
    if (!Array.isArray(value)) {
      return intl.formatMessage({ id: 'BookingTimeForm.requiredOption' });
    }

    const hasAtLeastOneSelected = value.some(item => {
      return Array.isArray(item?.option) && item.option.length > 0;
    });

    if (!hasAtLeastOneSelected) {
      return intl.formatMessage({ id: 'BookingTimeForm.requiredOption' });
    }

    return undefined;
  };

  return (
    <div className={classes}>
      <FieldArray name={arrayName} validate={validateOptions}>
        {filedsProps => {
          const { meta } = filedsProps;

          const textClassName = optionLabelClassName;
          const textClassNameMaybe = textClassName ? { textClassName } : {};

          return (
            <div>
              {options.map((name, index) => (
                <div key={options[index]?.key} className={css.item}>
                  <FieldCheckbox
                    id={`${arrayName}.${[index]}.option`}
                    name={`${arrayName}.${[index]}.option`}
                    label={options[index].label}
                    value={options[index].key}
                    {...textClassNameMaybe}
                  />
                </div>
              ))}

              {(meta.touched || meta.submitFailed) && meta.error && (
                <div className={css.error}>{meta.error}</div>
              )}
            </div>
          );
        }}
      </FieldArray>
    </div>
  );
};

FieldCheckboxGroupWithQuantity.defaultProps = {
  rootClassName: null,
  className: null,
  inputRootClass: null,
  onUnmount: null,
  customErrorText: null,
  id: null,
  label: null,
  isUncontrolled: false,
  inputRef: null,
};

FieldCheckboxGroupWithQuantity.propTypes = {
  rootClassName: string,
  className: string,
  inputRootClass: string,

  onUnmount: func,

  // Error message that can be manually passed to input field,
  // overrides default validation message
  customErrorText: string,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string,
  label: string,

  // Uncontrolled input uses defaultValue prop, but doesn't pass value from form to the field.
  // https://reactjs.org/docs/uncontrolled-components.html#default-values
  isUncontrolled: bool,
  // a ref object passed for input element.
  inputRef: object,
};

export default FieldCheckboxGroupWithQuantity;
